<template>
    <div>
      <!--boton para recargar-->
      <vs-button color="primary" type="filled" icon="refresh" @click="$emit('changeRecarge', true)"></vs-button>
      <br>
        <ul class="flex" style="flex-wrap:center;flex-wrap: wrap;">
            <li v-if="userAdmin == true || usuario.id_group == 27 " class="m-2">
                <vs-radio v-model="filtro" @input="filtroTipo();" vs-name="radios1tipo" vs-value="0"><span style="font-weight:bold;">{{sumaPendientes}}</span> Pendientes</vs-radio>
            </li>
            <li class="m-2">
                <vs-radio v-model="filtro" @input="filtroTipo();" vs-name="radios1tipo" vs-value="1"><span style="font-weight:bold;">{{ SumaAprobados }}</span> Aprobados</vs-radio>
            </li>
            <li class="m-2">
                <vs-radio v-model="filtro" @input="filtroTipo();" vs-name="radios1tipo" vs-value="2"><span style="font-weight:bold;">{{ SumaAprobadosPendientes }}</span> Aprobados con pendientes</vs-radio>
            </li>
            <li class="m-2">
                <vs-radio v-model="filtro" @input="filtroTipo();" vs-name="radios1tipo" vs-value="3"><span style="font-weight:bold;">{{ SumaEntregados }}</span> Entregados por bodega </vs-radio>
            </li>
            <li class="m-2">
                <vs-radio v-model="filtro" @input="filtroTipo();" vs-name="radios1tipo" vs-value="4"><span style="font-weight:bold;">{{ SumaAnulados }}</span> Anulados por facturación </vs-radio>
            </li>
            <li v-if="(usuario.id_group  == 22 || usuario.id_group == 23 || usuario.id_group == 27) && filtro==3" class="m-2">
                <vs-input  icon-after="true" style="width: 250px;"  icon="search" placeholder="Buscar Acta" v-model="busquedaxcodigo" @keyup.enter="filtrarPedidos()" />
            </li>
        </ul>
        <vs-table search :data="tmpPedidos" pagination max-items="10">
            <template slot="header">
                <vs-chip>Cantidad: {{ tmpPedidos.length }}</vs-chip>
                <!-- <p class="btn_lg font-semibold ml-2">Pedidos de guias </p> -->
            </template>
            <template slot="thead">
                <vs-th>#</vs-th>
                <vs-th sort-key="asesor">Asesor / Responsables</vs-th>
                <vs-th style="width: 140px;" sort-key="fecha_envio">Fechas</vs-th>
                <vs-th style="width: 80px;" sort-key="asesor">Cant. guias</vs-th>
                <vs-th sort-key="asesor">Estado</vs-th>
                <vs-th>Acciones</vs-th>
            </template>
            <template slot-scope="{data}">
                <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                    <vs-td> {{ tr.id_pedido }} </vs-td>
                    <vs-td>
                        <p class="font-bold">Responsable:</p>
                        <span>{{ tr.responsable }} </span>
                        <p class="font-bold">Cédula:</p>
                        <span>{{ tr.cedula }} </span>
                        <p v-if="filtro > 0" class="font-bold">Empresa:</p>
                        <span v-if="filtro > 0" >{{tr.empresa}}</span>
                        <p class="font-bold">Período solicitud:</p>
                        <vs-chip color="primary">{{ tr.periodo }} </vs-chip>
                        <div v-if="tr.facturacion_vee == 0">
                            <br>
                            <br>
                           <p class="text-danger font-bold">Facturador no puede ver</p>
                        </div>
                    </vs-td>
                    <vs-td>
                        <p class="font-bold">Fecha de envio:</p>
                        <span>{{ tr.fecha_envio.substring(0,10) }} </span>
                    </vs-td>
                    <vs-td>
                        {{ tr.total_unidades_guias }}
                    </vs-td>
                    <vs-td>
                        <div v-if="tr.estado == 2">
                            <vs-chip class="text-danger font-bold">Anulado</vs-chip>
                            <br><br>
                            <b>Anulado por:</b>
                            <p>{{ tr.usuario_anulado }}</p>
                            <b>Mensaje anulado:</b>
                            <p>{{ tr.message_anulado }}</p>
                            <br>
                        </div>
                        <p v-if="tr.observacion != null">
                            <vx-tooltip style="display: inline-block;" text="Ver Observación asesor" position="top" color="primary">
                                <vs-button  class="modal-default-button p-2" @click="pedido=tr;popupObservacion=true;" size="small" color="dark" type="filled" icon-pack="feather" icon="icon-message-circle">Ver observación </vs-button>
                            </vx-tooltip>
                        </p>
                        <span v-if="tr.estado_entrega == 0"><b>Pedido:</b><span class="ml-1">Creado</span></span>
                        <span color="primary" v-if="tr.estado_entrega == 1"><b>Pedido:</b><span class="ml-1">Aprobado por facturación</span></span>
                        <span color="success" v-if="tr.estado_entrega == 2"><b>Pedido:</b><span class="ml-1">Entregado por bodega</span></span><br>
                        <div v-if="tr.ven_codigo != null">
                            <p><b>Acta:</b> {{ tr.ven_codigo }}</p>
                        </div>
                        <b v-if="tr.estado_entrega > 0">Fecha aprobacion:</b>
                        <p v-if="tr.estado_entrega > 0">{{ tr.fecha_aprobado_facturacion }}</p>
                        <b v-if="tr.estado_entrega > 1">Fecha entrega bodega:</b>
                        <p v-if="tr.estado_entrega > 1">{{ tr.fecha_entrega_bodega }}</p>
                        <div v-if="tr.estado_entrega == '3'">
                          <p class="text-danger font-bold">Actas aprobadas</p>
                        </div>
                        <div v-if="tr.pendientes.length>0">
                          <div v-for="(p,index) in tr.pendientes" :key="index">
                            <p class="cursor-pointer my-2" @click="pedido=tr;ObjectPedidoHijo=p;f_mostrarDocumentoPendiente()" style="text-decoration: underline; color: #007BFF; font-size: 18px;">{{ p.ven_codigo }}</p>
                          </div>
                        </div>
                    </vs-td>
                    <vs-td align="center">
                        <vs-dropdown vs-custom-content vs-trigger-click>
                            <vs-button class="a-icons" href.prevent icon="more_vert" type="border"></vs-button>
                            <vs-dropdown-menu style="width: 250px;" class="cursor">
                                <!--APROBAR ACTA-->
                                <vs-dropdown-item v-if="groupFacturador && tr.ven_codigo == null && tr.estado == 1">
                                    <vx-tooltip style="display: inline-block;" text="AL PRESIONAR SE ENVIARA AL SISTEMA DE FACTURACION" position="top" color="primary">
                                     <vs-button class="w-full" color="dark"  icon-pack="feather" icon="icon-check" type="line" @click="verResumen =false;pedido = tr;tipoProceso=0;openConfirmEmpresa(0)">Aprobar solicitud</vs-button>
                                    </vx-tooltip>
                                </vs-dropdown-item>
                                <!--APROBAR PENDIENTES-->
                                <vs-dropdown-item v-if="groupFacturador && tr.estado_entrega == '3' && tr.estado == 1">
                                    <vs-button class="w-full" color="danger"  icon-pack="feather" icon="icon-check" type="line" @click="verResumen =false;pedido = tr;tipoProceso=0;openConfirmEmpresa(1)">Aprobar pendientes</vs-button>
                                </vs-dropdown-item>
                                <!--IMPRIMIR ACTA FACTURACION-->
                                <vs-dropdown-item v-if="( userAdmin == true ) && tr.ven_codigo != null">
                                    <vs-button class="w-full" color="#3541D3" icon-pack="feather" icon="icon-printer" type="line" @click="pedido = tr;ImprimirActa(0)">Imprimir acta(f)</vs-button>
                                </vs-dropdown-item>
                                <!--IMPRIMIR ACTA BODEGA-->
                                <vs-dropdown-item v-if="( usuario.id_group == 1  || usuario.id_group == 27 ) && tr.ven_codigo != null && (filtro == 1 || filtro == 2 || filtro == 3)">
                                    <vs-button class="w-full" color="#3541D3" icon-pack="feather" icon="icon-printer" type="line" @click="pedido = tr;ImprimirActa(1)">Imprimir acta(b)</vs-button>
                                </vs-dropdown-item>
                                <!--RESUMEN-->
                                <vs-dropdown-item >
                                    <vs-button class="w-full"  icon="visibility" type="line" @click="verResumen =true;pedido = tr;tipoProceso=0;openConfirmEmpresa()">Resumen</vs-button>
                                </vs-dropdown-item>
                                <!--ANULAR PEDIDO-->
                                <vs-dropdown-item v-if="groupFacturador && tr.estado == 1 && (tr.estado_entrega == 1 || tr.estado_entrega == 3 )">
                                    <vs-button class="w-full" color="danger" type="line" @click="pedido = tr;popupConfirmAnular=true;"><i class="fa-solid fa-delete-left"></i> Anular guia aprobada</vs-button>
                                </vs-dropdown-item>
                                <!--ENTREGAR GUIAS AL ASESOR(bodega)-->
                                <vs-dropdown-item v-if="(usuario.id_group == 17 || usuario.id_group == 27 || usuario.id_group == 1) && (tr.estado_entrega == 1) && tr.estado == 1">
                                    <!-- <vx-tooltip style="display: inline-block;" text="MARCAR COMO GUIAS ENTREGADAS AL ASESOR(BODEGA)" position="top" color="primary"> -->
                                        <vs-button class="w-full"  icon-pack="feather" color="dark" icon="icon-book" type="line" @click="pedido = tr;openConfirm(tr);">Entregar guias</vs-button>
                                    <!-- </vx-tooltip> -->
                                </vs-dropdown-item>
                                <!--REPORTE GUIA-->
                                <vs-dropdown-item v-if="usuario.id_group != 11">
                                    <vs-button class="w-full"  icon-pack="feather" icon="icon-file" @click="pedido = tr;getReporteGuia(tr);" color="success" type="line">Reporte guia</vs-button>
                                </vs-dropdown-item>
                                <!--ELIMINAR PEDIDO-->
                                <vs-dropdown-item v-if="tr.estado_entrega == 0 && tr.estado == 1">
                                    <vs-button class="w-full"  color="danger" type="line" @click="confirma_delete_pedido(tr)">Eliminar pedido</vs-button>
                                </vs-dropdown-item>
                            </vs-dropdown-menu>
                        </vs-dropdown>
                    </vs-td>
                </vs-tr>
            </template>
        </vs-table>
        <!--IMPRIMIR GUIA-->
        <vs-popup fullscreen v-if="mostrarReporteG" title="Reporte Guia" :active.sync="mostrarReporteG">
            <exportGuiasVue :id_periodo="pedido.id_periodo" :id_pedido="pedido.id_pedido" @change="changeHandle" />
        </vs-popup>
        <!--EXPORTAR ACTA FACTURADOR - ASESOR-->
        <vs-popup fullscreen v-if="mostrarImprimirActa" title="Acta" :active.sync="mostrarImprimirActa">
            <exportActaGuiasVue v-if="mostrarImprimirActa" :pedido="pedido" @change="changeHandle" />
        </vs-popup>
        <!--EXPORTAR ACTA BODEGA - ASESOR-->
        <vs-popup fullscreen v-if="mostrarImprimirActaBodega" title="Acta" :active.sync="mostrarImprimirActaBodega">
            <exportActaGuiasBodegaVue v-if="mostrarImprimirActaBodega" :pedido="pedido" @change="changeHandle" />
        </vs-popup>
        <!--EXPORTAR ACTA BODEGA -PENDIENTES-->
        <vs-popup fullscreen v-if="mostrarImprimirActaBodegaPendientes" title="Acta" :active.sync="mostrarImprimirActaBodegaPendientes">
          <div v-if="mostrarImprimirActaBodegaPendientes">
            <exportActaGuiasBodegaPendientesVue :pedido="pedido" :ObjectPedidoHijo="ObjectPedidoHijo" @change="changeHandle"/>
          </div>
        </vs-popup>
        <!--MODAL CARGAR-->
        <vs-popup class="holamundo" title="Cargando" :active.sync="popupCarga">
            <p class="text-warning text-3xl bg-dark"><i class="fa-solid fa-cloud"></i> <b class="ml-2">Espere mientras se descarga el archivo</b></p>
            <img class="mt-2" style="margin-left: 35px;" src="https://cdn-icons-png.flaticon.com/512/4578/4578845.png" />
        </vs-popup>
        <!--MODAL DETALLE DE LIBROS-->
        <vs-popup title="Detalle de libros" fullscreen :active.sync="modalLibros">
            <vs-table max-items="100" search pagination :data="arregloLibros">
                <template slot="header">
                    <div class="row">
                        <div class="col-12">Total Libros: <b>{{totalLibros}}</b></div>
                        <div class="col-12">Items: <b>{{arregloLibros.length}}</b></div>
                    </div>
                </template>
                <template slot="thead">
                    <vs-th>Libro</vs-th>
                    <vs-th>Cant. unidades</vs-th>
                    <vs-th>Precio unitario</vs-th>
                </template>
                <template slot-scope="{data}">
                    <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                        <vs-td>
                            {{data[indextr].nombrelibro}}<br>
                        </vs-td>
                        <vs-td>
                            {{data[indextr].valor}}<br>
                        </vs-td>
                        <vs-td>
                            {{tr.precio}}
                        </vs-td>
                    </vs-tr>
                </template>
            </vs-table>
        </vs-popup>
        <!--MODAL CONFIRMAR APROBAR-->
        <vs-popup class="holamundo" fullscreen title="Stock de guias" :active.sync="popupConfirmAprobar">
          <div v-if="popupConfirmAprobar">
            <p> <b>Empresa:</b> {{ arrayEmpresas.find(p => p.id == empresa.id).nombre }} <br></p>
            <p v-if="verResumen == false && pedido.estado_entrega != '3'" class="font-bold text-warning text-2xl text-center">Está seguro de aprobar la solicitud de guias?</p>
            <p v-if="verResumen == false && pedido.estado_entrega == '3'" class="font-bold text-warning text-2xl text-center">Aprobacion de guias pendientes</p>
            <GuiasStockVue v-if="popupConfirmAprobar" :arregloStock="arregloStock" :ObjectedSelected="pedido" :verResumen="verResumen" @changeAprobar="changeAprobar" @changeAprobarPendientes="changeAprobarPendientes"/>
            <div v-if="verResumen == false && pedido.estado_entrega != '3'">
              <vs-divider></vs-divider>
              <div v-if="NohayStock && ifAprobarSinStock == '0'">
                <vs-alert color="danger"><p class="text-center">No hay stock no se puede aprobar</p></vs-alert>
              </div>
              <div v-else-if="ifAprobarSinStock == '1'">
                <vs-alert color="warning"><p class="text-center">Aprobar sin stock</p></vs-alert>
                <div class="flex justify-center mt-4">
                  <vs-button color="primary" @click="enviarGuiasBDMilton();" type="border" icon="save">Si deseo aprobar</vs-button>
                  <vs-button color="warning" class="ml-2" @click="popupConfirmAprobar = false;" icon-pack="feather" type="filled" icon="icon-x-circle">Cancelar</vs-button>
                </div>
              </div>
              <div v-else>
                <div class="flex justify-center">
                  <vs-button color="primary" @click="enviarGuiasBDMilton();" type="border" icon="save">Si deseo aprobar</vs-button>
                  <vs-button color="warning" class="ml-2" @click="popupConfirmAprobar = false;" icon-pack="feather" type="filled" icon="icon-x-circle">Cancelar</vs-button>
                </div>
              </div>
            </div>
          </div>
          <br><br>
        </vs-popup>
        <!--MODAL PARA VER OBSERVACION DEL FACTURADOR-->
        <vs-popup classContent="popup-example" title="Ver comentario Asesor" :active.sync="popupObservacion">
            <p class="font-bold text-warning text-2xl">Comentario Asesor:</p>
            <vs-divider style="margin-top: -2px;"></vs-divider>
            <p class="">{{ pedido.observacion }}</p>
        </vs-popup>
        <!--MODADL PARA MOSTRAR LA EMPRESA -->
        <vs-popup classContent="popup-example" title="Empresa" :active.sync="popupMostrarEmpresa" @close="popupMostrarEmpresa = false;empresa=null;">
            <p class="font-bold text-warning text-2xl">Seleccione la Empresa:</p>
            <v-select :disabled="pedido.estado_entrega > 0" :options="arrayEmpresas" :reduce="arrayEmpresas => arrayEmpresas" label="nombre" class="w-full" v-model="empresa" />
            <br>
            <div class="flex justify-center mt-5">
              <!--seleccionar-->
              <vs-button icon="save" v-if="empresa" class="mr-3" @click="verStock">Seleccionar</vs-button>
              <!--cancelar-->
              <vs-button color="warning" class="ml-2" @click="popupMostrarEmpresa = false;empresa=null;" icon-pack="feather" type="filled" icon="icon-x-circle">Cancelar</vs-button>
            </div>
            <br><br><br>
        </vs-popup>
        <!--MODAL CONFIRMAR ANULACION-->
        <vs-popup class="holamundo" title="Anular pedido aprobado" :active.sync="popupConfirmAnular">
          <div v-if="popupConfirmAnular">
            <b>Documento:</b>
            <p>{{ pedido.ven_codigo }}</p>
            <p class="font-semibold mt-5 text-danger">Esta seguro de anular esta solicitud de guias. al hacerlo regresara el stock a bodega lo aprobado?</p>
            <vs-divider></vs-divider>
            <div>
                <p><b>Mensaje:</b></p>
                <vs-input v-model="message_anulado" placeholder="Escribe un mensaje para el usuario que anuló el pedido" type="textarea" rows="3" class="w-full"></vs-input>
            </div>
            <div class="flex justify-center mt-5">
                <vs-button color="danger" @click="anularPedido" type="border" icon="save">Si deseo anular</vs-button>
                <vs-button color="warning" class="ml-5" @click="popupConfirmAnular = false;" icon-pack="feather" type="filled" icon="icon-x-circle">Cancelar</vs-button>
            </div>
          </div>
        </vs-popup>
    </div>
    </template>
    <script>
    import {
      mapState
    } from "vuex";
    import exportGuiasVue from '../../../../temporadas/components/exportGuias.vue';
    import exportActaGuiasVue from '../../../../temporadas/components/exportActaGuias.vue';
    import exportActaGuiasBodegaVue from '../../../../temporadas/components/exportActaGuiasBodega.vue';
    import GuiasStockVue from '../GuiasStock.vue';
    import vSelect from 'vue-select'
    import Generalmix from "../../../../../mixins/Generalmix";
    const exportActaGuiasBodegaPendientesVue = () => import('../../../../temporadas/components/Pedidos/exportActaGuiasBodegaPendientes.vue')
    export default {
      mixins: [Generalmix],
      components: {
        exportGuiasVue,
        exportActaGuiasVue,
        exportActaGuiasBodegaVue,
        GuiasStockVue,
        exportActaGuiasBodegaPendientesVue,
        vSelect,
      },
        data() {
          return {
            usuario: [],
            tmpPedidos: [],
            pedido: {},
            id_pedido: 0,
            popupCarga: false,
            mostrarReporteG: false,
            mostrarImprimirActa:false,
            mostrarImprimirActaBodega:false,
            mostrarImprimirActaBodegaPendientes:false,
            pedidoGuiaEliminar: '',
            filtro: 0,
            arregloLibros: [],
            arregloStock:[],
            modalLibros: false,
            popupConfirmAprobar:false,
            verResumen:false,
            totalLibros: 0,
            userAdmin:false,
            userFacturador:false,
            NohayStock:false,
            popupObservacion:false,
            busquedaxcodigo:'',
            tipoProceso:0,
            popupMostrarEmpresa:false,
            arrayEmpresas:[],
            empresa:null,
            mixinIdInicioFormatoNewData: null,
            //variables para aprovar sin stock
            ifAprobarSinStock:false,
            arrayGuiasSend:[],
            //fin variables para aprovar sin stock
            ifAprobarPendientes:0,
            ObjectPedidoHijo:'',
            //variables para anular pedido
            message_anulado:'',
            popupConfirmAnular:false,
            //fin variables para anular pedido
          }
        },
        props: {
            pedidos: {
                type: Array,
                default: []
            },
            id_periodo: {
                type: Number,
                default: 0
            },
        },
        created() {
            let me = this;
            me.usuario = JSON.parse(localStorage.getItem("usuario"))
        },
        watch: {
            pedidos(results) {
                let me = this;
                me.tmpPedidos = []
                me.filtroTipo()
            },
        },
        mounted() {
            let me = this;
            // Verifica si los datos existen en localStorage
            const mixinData = localStorage.getItem('mixin_IdInicioFormatoNew');
            if (mixinData) {
            // Convierte el JSON en un array de objetos y extrae solo 'minimo' si existe
            const parsedData = JSON.parse(mixinData);
            me.mixinIdInicioFormatoNewData = parsedData.length > 0 ? parsedData[0].minimo : null;
            console.log("Valor de minimo:", me.mixinIdInicioFormatoNewData); // Verifica el valor en consola
            } else {
                console.warn("No se encontraron datos en localStorage para mixin_IdInicioFormatoNew");
            }
            // FIN Verificación si los datos existen en localStorage
            setTimeout(() => {
                me.filtroTipo()
            }, 1000);
            if(me.usuario.id_group == 27 || me.usuario.id_group == 17){
                me.filtro = 1
            }else{
                me.filtro = 0
            }
            //user admin
            if(me.usuario.id_group  == 22 || me.usuario.id_group == 23 || me.usuario.id_group == 1){
                me.userAdmin = true
            }
            //user facturador
            if(me.usuario.id_group  == 22 || me.usuario.id_group == 23){
                me.userFacturador = true
            }
        },
        computed: {
          ...mapState(["auth", 'userRoot', 'susuario', 'ObjectPedido', 'userAsesor', 'groupFacturador']),

            sumaPendientes() {
                let me = this;
                //pendientes admin bodega
                var predatos = []
                predatos = me.pedidos
                let datos = predatos.filter(p => (p.estado_entrega == 0) && (p.estado == 1));
                let resultado = datos.length
                return resultado
            },
            SumaAprobados() {
                let me = this;
                let datos = me.pedidos.filter(p => (p.estado_entrega == 1) && (p.estado == 1));
                let resultado = datos.length
                return resultado
            },
            SumaAprobadosPendientes() {
                let me = this;
                let datos = me.pedidos.filter(p => (p.estado_entrega == 3) && (p.estado == 1));
                let resultado = datos.length
                return resultado
            },
            SumaEntregados() {
                let me = this;
                let datos = me.pedidos.filter(p => (p.estado_entrega == 2) && (p.estado == 1));
                let resultado = datos.length
                return resultado
            },
            SumaAnulados(){
                let me = this;
                let datos = me.pedidos.filter(p => (p.estado == 2));
                let resultado = datos.length
                return resultado
            }
        },
        methods: {
          openConfirmEmpresa(){
            let me = this
            me.$http.get(me.$server_url+'empresa')
            .then(function (res) {
                if(res.data.status == 0){
                    me.$vs.notify({
                        text: res.data.message,
                        color: 'danger',
                        iconPack: 'feather',
                        icon: 'icon-alert-triangle',
                        time:3000
                    })
                    return
                }
                me.arrayEmpresas       = res.data
                //remover el id 2
                me.arrayEmpresas       = me.arrayEmpresas.filter(p => p.id != 2)
                //si pedido.estado_entrega es mayor a 0 colocar el id empresa en el campo empresa
                if(me.pedido.estado_entrega > 0){
                    me.empresa = me.arrayEmpresas.find(p => p.id == me.pedido.empresa_id)
                }
                me.popupMostrarEmpresa = true
            })
          },
          verStock(){
              let me = this;
              me.arregloStock = []
              if(me.empresa == null || me.empresa == "" || me.empresa == undefined){
                  me.$vs.notify({
                      text: 'Seleccione una empresa',
                      color: 'danger',
                      iconPack: 'feather',
                      icon: 'icon-alert-triangle',
                      time:3000
                  })
                  return
              }
              me.popupMostrarEmpresa = false
              me.$vs.loading()
              var url = ""
              //resumen para facturacion
              // if(me.tipoProceso == 0){
                  if(me.pedido.id_periodo <= me.mixinIdInicioFormatoNewData){
                      var url = this.$server_url+'guias?verStock=yes&id_pedido='+me.pedido.id_pedido+'&empresa='+me.empresa.id
                  }else if(me.pedido.id_periodo > me.mixinIdInicioFormatoNewData){
                      var url = this.$server_url+'guias?verStock_new=yes&id_pedido='+me.pedido.id_pedido+'&empresa='+me.empresa.id
                  }
              //}
              // //resumen para bodega
              // if(me.tipoProceso == 1){
              //     if(me.pedido.id_periodo <= me.mixinIdInicioFormatoNewData){
              //         url = this.$server_url+'guias?verStockGuiasProlipa=yes&id_pedido='+me.pedido.id_pedido+'&acta='+me.pedido.ven_codigo
              //     }else if(me.pedido.id_periodo > me.mixinIdInicioFormatoNewData){
              //         url = this.$server_url+'guias?verStockGuiasProlipa_new=yes&id_pedido='+me.pedido.id_pedido+'&acta='+me.pedido.ven_codigo
              //     }
              // }
              this.$http.get(url)
                  .then(function (res) {
                      me.$vs.loading.close()
                      if(res.data.status == 0){
                          me.$vs.notify({
                              text: res.data.message,
                              color: 'danger',
                              iconPack: 'feather',
                              icon: 'icon-alert-triangle',
                              time:3000
                          })
                          return
                      }
                      //ingresar libros en array
                      let datos = res.data
                      if(me.tipoProceso == 0){
                          //validate que haya stock
                          let validate = datos.filter(p => p.nuevoStock < 1)
                          if(validate.length > 0){
                              me.NohayStock = true
                          }else{
                              me.NohayStock = false
                          }
                          //fin validate que haya stock
                      }

                      var predatos = []
                      predatos = datos
                      me.arregloStock = predatos.sort(function(a, b) {
                          var nombreA = a.nombrelibro.toLowerCase();
                          var nombreB = b.nombrelibro.toLowerCase();
                          var numA = parseInt(nombreA.match(/\d+$/)); // extraer el número del final (si existe)
                          var numB = parseInt(nombreB.match(/\d+$/)); // extraer el número del final (si existe)
                          nombreA = nombreA.replace(/\d+$/, ''); // quitar el número del final
                          nombreB = nombreB.replace(/\d+$/, ''); // quitar el número del final

                          if (nombreA < nombreB) {
                              return -1;
                          }
                          if (nombreA > nombreB) {
                              return 1;
                          }
                          if (numA && !numB) { // si a tiene número y b no, b va primero
                              return 1;
                          }
                          if (!numA && numB) { // si b tiene número y a no, a va primero
                              return -1;
                          }
                          if (numA && numB) { // si ambos tienen número, compararlos
                              if (numA < 10 && numB >= 10) { // si a es menor que 10 y b es 10 o mayor, a va primero
                              return -1;
                              }
                              if (numA >= 10 && numB < 10) { // si b es menor que 10 y a es 10 o mayor, b va primero
                              return 1;
                              }
                              return numA - numB; // comparar los números directamente
                          }
                          return 0; // si son iguales en todo, no hay diferencia
                      });
                      //open confirm
                      //del arregloStock separar en un propiedad cantidad_descontar color el nuevoStock que  sea menor a 0
                      me.arregloStock.forEach(item => {
                          item.cantidadAutorizar = 0
                          if(item.nuevoStock < 0){
                              item.cantidad_descontar = Math.abs(item.nuevoStock)
                          }else{
                              item.cantidad_descontar = 0
                          }
                      })
                      me.popupConfirmAprobar = true
                  })
                  .catch(function (error) {
                      console.log(error + ' error');
                      me.$vs.loading.close()
                      me.$vs.notify({
                          text: "Ocurrio un error al cargar los datos",
                          color: 'danger',
                          iconPack: 'feather',
                          icon: 'icon-alert-triangle',
                          time:3000
                      })
                  })

          },
          enviarGuiasBDMilton(){
              let me = this
              let nuevarutaxperiodo = '';
              //validacion
              if(me.pedido.codigo_contrato == null || me.pedido.codigo_contrato == "" || me.pedido.codigo_contrato == undefined || me.pedido.iniciales == "" || me.pedido.iniciales == null || me.pedido.iniciales == "null"){
                  me.$vs.notify({
                      text: 'El codigo del periodo o las iniciales del asesor no estan configuradas',
                      color: 'primary',
                      iconPack: 'feather',
                      icon: 'icon-alert-triangle'
                  })
                  return
              }
              if(me.usuario.cod_usuario == null || me.usuario.cod_usuario == "null" || me.usuario.cod_usuario == "" || me.usuario.cod_usuario == undefined){
                  me.$vs.notify({
                      text: 'El codigo del usuario facturador no esta configurado',
                      color: 'primary',
                      iconPack: 'feather',
                      icon: 'icon-alert-triangle'
                  })
                  return
              }
              let formData = new FormData();
              formData.append('id_pedido',            me.pedido.id_pedido)
              formData.append('codigo_contrato',      me.pedido.codigo_contrato)
              formData.append('iniciales',            me.pedido.iniciales);
              formData.append('usuario_fact',         me.usuario.idusuario)
              formData.append('codigo_usuario_fact',  me.usuario.cod_usuario);
              formData.append('region_idregion',      me.pedido.region_idregion)
              formData.append('asesor_id',            me.pedido.id_asesor)
              formData.append('id_periodo',           me.pedido.id_periodo)
              formData.append('empresa_id',           me.empresa.id)
              formData.append('guias_send',           JSON.stringify(me.arrayGuiasSend))
              formData.append('ifAprobarSinStock',    me.ifAprobarSinStock)
              formData.append('ifAprobarPendientes',  me.ifAprobarPendientes)
              if(me.ifAprobarPendientes == '1'){
                formData.append('ven_codigoPadre',me.pedido.ven_codigo)
              }
              if (me.pedido.id_periodo <= me.mixinIdInicioFormatoNewData) {
                formData.append('ifnuevo',            0)

              }else if (me.pedido.id_periodo > me.mixinIdInicioFormatoNewData) {
                formData.append('ifnuevo',            1)

              }
              me.$vs.loading()
              for (let [key, value] of formData.entries()) {
                  console.log(`${key}: ${value}`);
              }
                if(me.ifAprobarPendientes == '1'){
                    formData.append('guardarGuiasPendientes',1)
                    nuevarutaxperiodo = 'guias';
                }else{
                    nuevarutaxperiodo = 'guardarGuiasBDMilton_new';
                }
              this.$http.post(this.$server_url+nuevarutaxperiodo, formData)
              .then(function (res) {
                  me.$vs.loading.close()
                  if(res.data.status == 0){
                      me.$vs.notify({
                          text: res.data.message,
                          color: 'danger',
                          iconPack: 'feather',
                          icon: 'icon-alert-triangle',
                          time:3000
                      })
                      return
                  }
                  me.$vs.notify({
                      text: 'Se guardo correctamente',
                      color: 'primary',
                      iconPack: 'feather',
                      icon: 'icon-alert-triangle'
                  })
                  me.popupConfirmAprobar = false;
                  me.popupMostrarEmpresa = false;
                  me.ifAprobarPendientes = 0
                  me.arrayGuiasSend      = []
                  me.ifAprobarSinStock   = 0
                  me.$emit('changeRecarge', true)
              })
              .catch(function (error) {
                  me.$vs.loading.close();
                  // Manejo de errores HTTP 500 y otros errores
                  let errorMessage = 'Error desconocido';
                  if (error.response && error.response.data && error.response.data.message) {
                      errorMessage = error.response.data.message;
                  }
                  me.$vs.notify({
                      text: errorMessage,
                      color: 'danger',
                      iconPack: 'feather',
                      icon: 'icon-alert-triangle'
                  });
              });
          },
          changeHandle(e) {
              let me                                  = this;
              me.popupCarga                           = false
              me.mostrarReporteG                      = false
              me.mostrarImprimirActa                  = false
              me.mostrarImprimirActaBodega            = false
              me.mostrarImprimirActaBodegaPendientes  = false
              me.pedido                               = {}
              me.ObjectPedidoHijo                     = { }
          },
          ver_pedido(item) {
              let me = this;
              localStorage.setItem("id_periodo_selected", item.id_periodo)
              localStorage.setItem("nombre_periodo_selected", item.periodo)
              this.$store.dispatch('setGuia',item)
              this.$emit('showPedido',1)
          },
          getReporteGuia(tr) {
              let me = this;
              localStorage.setItem("id_periodo_selected", tr.id_periodo)
              localStorage.setItem("nombre_periodo_selected", tr.periodo)
              me.id_pedido = tr.id_pedido
              // me.popupCarga = true
              me.mostrarReporteG = true
          },
          ImprimirActa(tipo){
              let me                              = this;
              // me.popupCarga                       = true
              if(tipo == 0){
                  me.mostrarImprimirActa          = true
              }
              if(tipo == 1){
                  me.mostrarImprimirActaBodega    = true
              }

          },
          f_mostrarDocumentoPendiente(){
            let me = this
            me.mostrarImprimirActaBodegaPendientes = true
          },
          confirma_delete_pedido(item) {
              let me = this;
              me.pedidoGuiaEliminar = item;
              me.$vs.dialog({
                  type: 'confirm',
                  color: 'danger',
                  title: 'Confirmar',
                  text: 'Seguro desea eliminar este pedido?. No lo podrá recuperar',
                  acceptText: 'Aceptar',
                  cancelText: 'Cancelar',
                  accept: me.f_eliminarGuiaPedido
              })
          },
          f_eliminarGuiaPedido() {
              let me = this;
              let rutaperiodofinal = '';
              if (me.pedidoGuiaEliminar.id_periodo <= me.mixinIdInicioFormatoNewData) {
                  rutaperiodofinal = 'deletePedidoGuia/';
              }else if(me.pedidoGuiaEliminar.id_periodo > me.mixinIdInicioFormatoNewData){
                  rutaperiodofinal = 'deletePedidoGuia_new/';
              }
              this.$http.get(this.$server_url + rutaperiodofinal + me.pedidoGuiaEliminar.id_pedido)
                  .then((result) => {
                      console.log(result.data)
                      me.$vs.notify({
                          color: 'danger',
                          text: 'Pedido eliminado correctamente'
                      })
                      me.$emit('changeRecarge', true)
                  }).catch((err) => {
                      console.log(err)
                  });
          },
          filtroTipo(dato) {
              let me = this;
              me.tmpPedidos = []
              //para ver los pedidos pendientes
              if (me.filtro == 0) {
                  //bodega mostrar los pedidos pendientes de bodega
                  var predatos = []
                  predatos = me.pedidos
                  let datos = predatos.filter(p => (p.estado_entrega == 0 && p.estado == 1));
                  me.tmpPedidos = datos
                  return
              }
              //para ver los pedidos aprobados
              else if (me.filtro == 1) {
                  let datos = me.pedidos.filter(p => (p.estado_entrega == 1) && p.estado == 1);
                  me.tmpPedidos = datos
                  return
              }
              //para ver los pedidos pendientes
              else if (me.filtro == 2) {
                  let datos = me.pedidos.filter(p => (p.estado_entrega == 3) && p.estado == 1);
                  me.tmpPedidos = datos
                  return
              }
              // entregados por bodega
              else if(me.filtro == 3){
                if(dato){
                    let datos = me.pedidos.filter(guias => {
                          return (guias.estado_entrega == 2 && guias.estado == 1) && guias.ven_codigo.toString().toUpperCase().includes(dato.toUpperCase());
                    });
                    me.tmpPedidos = datos;
                    return;
                }else{
                    let datos = me.pedidos.filter(g => (g.estado_entrega == 2) && g.estado == 1);
                    me.tmpPedidos = datos;
                    return;
                }
              }
              // anulados por facturacion
              else if(me.filtro == 4){
                var predatos = []
                predatos = me.pedidos
                let datos = predatos.filter(p => (p.estado == 2));
                me.tmpPedidos = datos
                return
              }
          },
          filtrarPedidos() {
              let me = this;
              const busqueda = this.busquedaxcodigo.toUpperCase();
              if (busqueda.length > 0 && this.filtro == 3) {
                  this.filtroTipo(busqueda);
              }else{
                  this.filtroTipo(busqueda);
                      me.$vs.notify({
                      text: 'No tiene datos de',
                      color: 'danger',
                      iconPack: 'feather',
                      icon: 'icon-alert-triangle'
                  })
              }
          },
          //====METODOS DE BODEGA======
          openConfirm(){
              this.$vs.dialog({
                  type:'confirm',
                  color: 'danger',
                  title: `Confirmar`,
                  acceptText:'aceptar',
                  cancelText:'cancelar',
                  text: 'Esta seguro de entregar esta solicitud de guias?',
                  accept:this.entregarPedido
              })
          },
          entregarPedido() {
              let me = this
              me.$vs.loading();
              let data = {
                  'id_pedido': this.pedido.id_pedido,
                  'estado': '2',
                  'grupo': 'bodega',
                  'acta':this.pedido.ven_codigo,
                  'asesor_id':this.pedido.id_asesor
              }
              this.$http.post(this.$server_url + 'entregarPedido', data)
                  .then(res => {
                      me.f_notificaciones('Pedido entregado', 'success', 'check')
                      me.$emit('changeRecarge', true)
                      me.$vs.loading.close();
                  })
                  .catch(err => {
                      console.log(err)
                      me.$vs.loading.close();
                  })
          },
          f_notificaciones(msj, color, icono) {
              let me = this;
              me.$vs.notify({
                  text: msj,
                  color: color,
                  iconPack: 'feather',
                  icon: icono
              })
              return;
          },
          //====FIN METODOS DE BODEGA====
          //METODOS PARA APROBAR SIN STOCK
          changeAprobar(e,guiasSend=[]){
              let me = this
              me.arrayGuiasSend     = []
              me.ifAprobarSinStock  = e
              me.arrayGuiasSend     = guiasSend
            //   me.verStock()
          },
          changeAprobarPendientes(e){
            let me = this
            me.arrayGuiasSend     = []
            me.arrayGuiasSend     = e
            me.popupConfirmAprobar = false
            me.f_confirmarAprobarPendientes()
          },
          f_confirmarAprobarPendientes(){
            let me = this
            me.ifAprobarPendientes = 1
            this.$vs.dialog({
              type:'confirm',
              color: 'danger',
              title: `Confirm`,
              text: `¿Estás seguro de aprobar las guias pendientes de ${this.arrayGuiasSend.length} libros?`,
              accept:this.enviarGuiasBDMilton,
              acceptText:'Aceptar',
              cancelText:'Cancelar',
              cancel: () => {
                me.popupConfirmAprobar = true;
              }
            })
          },
          //METODOS PARA ANULAR PEDIDO
          anularPedido() {
            let me = this
            //quitar espacios
            me.message_anulado = me.message_anulado.trim();
            if(me.message_anulado == ''){
                me.m_message('Escribe un mensaje porque se anuló el pedido', 'danger', 'alert-triangle')
                return
            }
        
            me.$vs.loading();
            let formData = new FormData();
            formData.append('anularPedidoAprobado', 1)
            formData.append('id_pedido',            me.pedido.id_pedido)
            formData.append('user_created',         me.usuario.idusuario)
            formData.append('message_anulado',      me.message_anulado)
            if (me.pedido.id_periodo <= me.mixinIdInicioFormatoNewData) {
            formData.append('ifnuevo',            0)

            }else if (me.pedido.id_periodo > me.mixinIdInicioFormatoNewData) {
            formData.append('ifnuevo',            1)

            }
            this.$http.post(this.$server_url + 'guias', formData)
            .then(res => {
                me.$vs.loading.close();
                if(res.data.status == 0){
                    me.m_message(res.data.message, 'danger', 'alert-triangle')
                    return
                }
                me.m_message(res.data.message, 'success', 'check')
                me.popupConfirmAnular = false;
                me.message_anulado = '';
                me.$emit('changeRecarge', true)
            })
            .catch(err => {
            console.log(err)
            me.$vs.loading.close();
            })
          },
        }
    }
    </script>
